// @ts-check

import Node from "./node"
import Log from "../core/logging"

import {
  txt2dom
} from "../core/utilities"

// import { guard } from "../core/functions"

const log = new Log()

log.name = "VDOM:"
// log.silent = false;

const TEXT_NODE = 3
const CDATA_SECTION_NODE = 4
// const DOCUMENT_FRAGMENT_NODE = 11

const copyArray = array => {
  return [].slice.call(array)
}

const getFormattedNodes = nodes => nodes.map(c => c.dom)

const getObsoleteNodes = (nodes, node) => {
  nodes = copyArray(nodes).filter(c => c.nodeType !== TEXT_NODE)

  let keep = getFormattedNodes(node.children)
  let toDelete = nodes
    .filter(n => {
      if (keep.contains(n)) {
        return false
      }
      return true
    })
    .map(n => {
      return {
        type: "delete",
        node: n
      }
    })
  return toDelete
}

const getNewNodes = nodes => {
  // find nodes to add
  let toAdd = nodes
    .filter(n => n.dom === null)
    .map(n => ({
      type: "append",
      node: n
    }))
  return toAdd
}

const compareAttributes = node => {
  let change = false
  Object.keys(node.style).forEach(k => {
    if (node.style[k] !== node.dom.style[k]) {
      change = true
    }
  })

  Object.keys(node.dataset).forEach(k => {
    if (node.dataset[k] !== node.dom.dataset[k]) {
      change = true
    }
  })

  Object.keys(node.attrs).forEach(k => {
    if (node.attrs[k] !== node.dom.getAttribute(k)) {
      change = true
    }
  })

  let data = node.getData()

  if (data != null) {
    if (node.content !== data.string) {
      change = true
    }
  }
  return change
}

const getUpdatedNodes = nodes => {
  let toUpdate = nodes
    .filter(c => {
      if (!c.dom) {
        // handled by append?
        return false
      }

      return compareAttributes(c)
    })
    .map(c => ({
      type: "update",
      node: c
    }))
  // return {};
  return toUpdate
}

// const removeMember = (array, item) => {
//   let arr = copyArray(array);

//   let i = arr.indexOf(item);
//   if (i > -1) {
//     arr.splice(i, 1);
//   }
//   return arr;
// }

const processChanges = changes => {
  let instr = {
    append: [],
    update: [],
    delete: []
  }
  if (!changes) {
    return instr
  }

  changes
    .filter(c => c.type)
    .forEach(c => {
      if (!instr[c.type]) {
        instr[c.type] = []
      }
      if (!instr[c.type].contains(c)) {
        instr[c.type].push(c.node)
      }
    })

  const filterDeleted = c => !instr.delete.contains(c)

  instr.update = instr.update.filter(filterDeleted)

  instr.append = instr.append.filter(filterDeleted)

  return instr
}

const compare = (node, changes) => {
  if (!changes) {
    changes = []
  }

  if (node.dom) {
    // find nodes to delete
    let toDelete = getObsoleteNodes(node.dom.childNodes, node)
    changes = changes.concat(toDelete)
  }

  // find nodes to add
  let toAdd = getNewNodes(node.children)
  changes = changes.concat(toAdd)

  // refresh each node
  let toRefresh = getUpdatedNodes(node.children)
  changes = changes.concat(toRefresh)

  node.children.forEach(c => {
    if (toAdd.indexOf(c) < 0) {
      changes = compare(c, changes)

      // reorder nodes
      // let el = c.dom;
      // if (parent && el) {
      //   //                parent.removeChild(el);
      //   //                parent.appendChild(el);
      // }
    }
  })

  return changes
}

const applyChanges = changes => {
  changes.delete.forEach(c => c.remove())
  changes.append.forEach(c => c.rerender())
  changes.update.forEach(c => c.refresh())
}

const patchDOM = tree => {
  let root = tree.findFirstDOM()

  if (!root) {
    return
  }

  // let ctx = this;
  let changes = compare(root)

  changes = processChanges(changes)

  applyChanges(changes)
}

const copyNode = (node, copy) => {
  if (node.attributes) {
    Object.keys(node.attributes).forEach(k => {
      let attr = node.attributes[k]
      let key = attr.name
      let value = attr.value
      if (key && value) {
        copy.attrs[key] = value
      }
    })
  }

  if (node.dataset) {
    // let dataset = node.dataset;
    // for (let [key, value] of Object.entries (dataset)) {
    //   copy.dataset[key] = value;
    // }
    copy.dataset = {
      ...node.dataset
    }
  }
  if (node.style) {
    let style = node.style
    Object.keys(style)
      .filter(k => {
        return ["cssText", "length", "0"].indexOf(k) < 0
      })
      .forEach(k => {
        if (style[k]) {
          copy.style[k] = style[k]
        }
      })
  }
  log.info(
    "copyNode: content:",
    copy.tag,
    copy.content,
    copy,
    "type:",
    node.nodeType,
    node.textContent
  )
  if (node.tagName === "STYLE") {
    copy.content = node.textContent
  }
}

const importDOM = function(node) {
  let copy = new Node()
  log.info("importDOM:", node)
  if (node.nodeType === TEXT_NODE) {
    // text node
    if (node.nodeValue) {
      copy.nodeType = node.nodeType
      copy.content = node.nodeValue // node.data
      return copy
    } else {
      return
    }
  }

  if (node.tagName) {
    copy.tag = node.tagName.toLowerCase()
  } else if (node.nodeType === CDATA_SECTION_NODE) {
    // cdata section
    copy.nodeType = node.nodeType
    copy.content = node.nodeValue
  } else {
    // not a dom element: whitespace?
    log.info("importDOM: skip?:", node)
    //            return;
  }

  copyNode(node, copy)

  let children = Array.prototype.slice
    .call(node.childNodes)
    .map(c => importDOM(c))
    .filter(c => c) // ? compact array?

  if (children.length === 1 && children[0].nodeType === TEXT_NODE) {
    copy.content = children[0].content
  } else {
    children.forEach(c => {
      copy.append(c)
    })
  }
  return copy
}

let parseObject = function(obj) {
  let n = new Node()

  ;
  ["tag", "attrs", "style", "dataset", "content"].forEach(p => {
    n[p] = obj[p]
  })

  obj.children &&
    obj.children.forEach(c => {
      let child = parseObject(c)
      child.parent = n
      n.children.push(child)
    })

  return n
}

const toString = node => {
  return JSON.stringify(node, (key, value) => {
    switch (key) {
      case "parent":
      case "dom":
      case "data":
        return null
      default:
        return value
    }
  })
}

const importHTML = txt => {
  return importDOM(txt2dom(txt)[0])
}

const importString = string => {
  return parseObject(JSON.parse(string))
}

const treeToObject = node => {
  return JSON.parse(
    JSON.stringify(node, (key, value) => {
      switch (key) {
        case "parent":
        case "dom":
        case "data":
          return null
        default:
          return value
      }
    })
  )
}

const copyTree = node => {
  return parseObject(treeToObject(node))
}

let VDOM = (() => {
  return {
    Node: Node, // captalized, because it is a type
    // node: Node, // remove

    // TODO: review these names
    importDOM: importDOM,
    parseObject: parseObject,
    copyTree: copyTree,
    treeToObject: treeToObject,
    importString: importString,
    importHTML: importHTML,
    toString: toString,

    patchDOM: patchDOM
  }
})()

export default VDOM